exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".isletmedefteri[data-v-7582c93c]{height:740px;background:#fff;padding:20px 0 0;font-size:9px!important;margin-bottom:30px}ul.isletmelist[data-v-7582c93c]{list-style-type:decimal-leading-zero;text-align:left;margin:0;padding:0}.cift-border[data-v-7582c93c]{border:5px double #000;padding:5px;height:690px}ul.isletmelist li[data-v-7582c93c]{padding:1px 0;text-align:left;margin-left:20px}.isletmetable[data-v-7582c93c]{margin:10px -10px}.isletmetable.table>tbody>tr>td[data-v-7582c93c],.isletmetable.table>tbody>tr>th[data-v-7582c93c],.isletmetable.table>thead>tr>th[data-v-7582c93c]{font-size:9px!important;padding:2px 5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7582c93c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Raporlama/ozel/proje.vue
// module id = 1192
// module chunks = 0